import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Form } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Check } from 'lucide-react';
import services from 'services';
import BasicForm from 'components/forms/patients/BasicForm';
import PatientDetailsForm from 'components/forms/patients/PatientDetailsForm';
import localeTranslator from 'library/Hocs/LocalTranslator';
import Loader from 'components/AntEnhancement/Loader';
import '../NewPatient/style.css';
var UpdatePatient = function (props) {
    var t = props.translate;
    var navigate = useNavigate();
    var id = useParams().id;
    var _a = useState(false), isFemale = _a[0], setIsFemale = _a[1];
    var _b = useState(0), reRenderCount = _b[0], setReRenderCount = _b[1];
    var _c = useState('male'), gender = _c[0], setGender = _c[1];
    var _d = useState(false), disabled = _d[0], setDisabled = _d[1];
    var form = Form.useForm()[0];
    var patientService = services.patientService, patientAreaService = services.patientAreaService;
    var _e = patientService.useUpdatePatient(), updatePatient = _e.mutate, errorResponse = _e.error;
    var patient = patientService.useGetPatient(Number(id)).data;
    var patientAreas = patientAreaService.usePatientAreas().data;
    var submit = function () {
        setDisabled(true);
        if (!patient)
            return;
        updatePatient({
            patient: patient,
            successMessage: t('patientUpdated')
        }, {
            onSuccess: function () { return navigate("/patients/".concat(patient.getId())); }
        });
    };
    useEffect(function () {
        if (errorResponse)
            setDisabled(false);
    }, [errorResponse]);
    useEffect(function () {
        if (patient && reRenderCount === 0) {
            setReRenderCount(1);
            setGender(patient.getGender());
        }
        if (patient)
            setIsFemale(gender === 'female');
    }, [patient, gender, reRenderCount]);
    var scrollToFirstElement = function () {
        return form.scrollToField('firstName', { behavior: 'smooth' });
    };
    var goBack = function () { return navigate("/patients/".concat(id)); };
    return (_jsx(Loader, { renderSpinner: !patient, children: _jsxs("div", { className: "patient-form-page", children: [_jsxs("header", { className: "patient-form-page__header", children: [_jsxs("div", { className: "patient-form-page__title-row", children: [_jsx("button", { type: "button", className: "patient-form-page__back", onClick: goBack, "aria-label": t('common:buttons.cancel'), children: _jsx(ArrowLeft, { size: 18, strokeWidth: 2 }) }), _jsxs("div", { children: [_jsx("h1", { className: "patient-form-page__title", children: t('title') }), _jsx("p", { className: "patient-form-page__subtitle", children: t('subtitle') })] })] }), _jsxs("div", { className: "patient-form-page__actions", children: [_jsx("button", { type: "button", className: "patient-form-page__btn patient-form-page__btn--ghost", onClick: goBack, children: t('common:buttons.cancel') }), _jsxs("button", { type: "button", className: "patient-form-page__btn patient-form-page__btn--primary", disabled: disabled || !patient, onClick: function () { return form.submit(); }, children: [_jsx(Check, { size: 16, strokeWidth: 2 }), _jsx("span", { children: t('savePatient') })] })] })] }), _jsx("div", { className: "patient-form-page__canvas", children: _jsxs(Form, { className: "patient-form", layout: "vertical", form: form, onFinish: submit, onFinishFailed: scrollToFirstElement, requiredMark: false, children: [_jsxs("p", { className: "patient-form-page__hint", children: [_jsx("span", { children: "*" }), " ", t('requiredHint')] }), patient && patientAreas && (_jsx(BasicForm, { patient: patient, patientAreas: patientAreas, setGender: setGender })), patient && (_jsx(PatientDetailsForm, { patient: patient, isFemale: isFemale }))] }) })] }) }));
};
export default localeTranslator(UpdatePatient, 'patientUpdate');
